import { Component, OnInit } from '@angular/core';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';
import { NgForm } from '@angular/forms';
//import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-adminmessage',
  templateUrl: './adminmessage.component.html',
  styleUrls: ['./adminmessage.component.css']
})
export class AdminmessageComponent implements OnInit {
  data: any;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  userid = [];
  sp: any;
  selectedRoleOrder: any;
  constructor(private vendordashboard: VendordashboardService, private tendering: TenderingService,
    private admindashboard: AdmindashboardService) { }

  ngOnInit() {

    this.GetVendorsList();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'fullName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    console.log(this.dropdownSettings);
  }
  GetVendorsList() {
    //debugger;
    this.tendering.GetVendorsList().subscribe(
      (data: any) => {
        this.dropdownList = data;

        console.log(this.dropdownList);
      }
    )
  }
  onItemSelect(idField) {
    // console.log(idField);
    // this.sp = ",";
    // this.userid += idField.id + this.sp;
    //this.userid = idField.id;
    // console.log(idField);

  }
  messagesend(form: NgForm) {
    //alert("messagesend");
    debugger;
    console.log(this.selectedItems);
    form.value.toUserId = "";
    if (form.value.message != "" && form.value.selectedItems[0].fullName != "") {
      if (!isNullOrUndefined(this.selectedItems)) {
        for (var i = 0; i < this.selectedItems.length; i++) {
          if (i < this.selectedItems.length - 1) {
            form.value.toUserId = form.value.toUserId + this.selectedItems[i].id + ",";
          }
          else {
            form.value.toUserId = form.value.toUserId + this.selectedItems[i].id;
          }
        }
      }

      this.admindashboard.adminmessagesend(form.value).subscribe(
        (data) => {
          this.data = data;
          if (this.data == true) {
            alert("Message Sent");
            form.reset();
          }
          console.log(data);
        })
    }
    else {

    }

  }

}
